<div class="landing-brand-wrapper">
  <figure class="landing-brand-figure landing-brand-figure--background">
    <img [src]="backgroundImage" [alt]="backgroundAlt" loading="lazy" />
  </figure>
  <div class="landing-brand-overlay"></div>
  <div class="landing-brand-footer">
    <figure class="landing-brand-figure landing-brand-figure--shop">
      <img [src]="logo" [alt]="logoAlt" loading="lazy" />
      <div class="box-swiper-preloader"></div>
    </figure>
    <span class="landing-brand-name">{{ name }}</span>
  </div>
</div>
